// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MainContentQuartoInformacoesGerais_sectionTitle__wT8xi","placeholderShimmer":"MainContentQuartoInformacoesGerais_placeholderShimmer__1k6xo"};